module.exports = __webpack_public_path__ + "img/h2p-equip-abilities.91db8ce4.png";